var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgObject = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.783.462H3.235A2.774 2.774 0 0 0 .461 3.235v5.548a2.773 2.773 0 0 0 2.774 2.773h5.548a2.774 2.774 0 0 0 2.773-2.773V3.235A2.774 2.774 0 0 0 8.783.462Zm.924 8.32a.924.924 0 0 1-.924.925H3.235a.924.924 0 0 1-.924-.924V3.235a.924.924 0 0 1 .924-.924h5.548a.924.924 0 0 1 .924.924v5.548Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.726.462H16.18a2.774 2.774 0 0 0-2.774 2.773v5.548a2.773 2.773 0 0 0 2.774 2.773h5.547A2.773 2.773 0 0 0 24.5 8.783V3.235A2.773 2.773 0 0 0 21.726.462Zm.925 8.32a.924.924 0 0 1-.925.925H16.18a.924.924 0 0 1-.924-.924V3.235a.923.923 0 0 1 .924-.924h5.547a.924.924 0 0 1 .925.924v5.548Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.783 13.405H3.235A2.774 2.774 0 0 0 .461 16.18v5.548A2.773 2.773 0 0 0 3.235 24.5h5.548a2.774 2.774 0 0 0 2.773-2.773v-5.548a2.774 2.774 0 0 0-2.773-2.773Zm.924 8.322a.923.923 0 0 1-.924.924H3.235a.924.924 0 0 1-.924-.924v-5.548a.924.924 0 0 1 .924-.924h5.548a.923.923 0 0 1 .924.924v5.548Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.575 18.028h-3.698V14.33a.924.924 0 1 0-1.849 0v3.698H14.33a.925.925 0 0 0 0 1.85h3.698v3.698a.925.925 0 0 0 1.85 0v-3.699h3.697a.924.924 0 1 0 0-1.849Z"
  })));
};
export { SvgObject as ReactComponent };